export const newBaseUrl = `https://backend.arch-sense.com/public`;
// export const newBaseUrl = `http://127.0.0.1:8000`;
const storedLanguage = localStorage.getItem('language');
export const initialLanguage = storedLanguage || 'en';
